module.exports = __webpack_public_path__ + "static/media/17_plantilla_cuadrada_combo_simple_cf_stills_pet_15_cepita_fresh_man.1c65f4f9.png";